import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { contactSupportFlag } from 'redux/user/actions';
import { setHeaderPanelExpand } from 'redux/app/actions';
import { Button } from 'carbon-components-react';

const ContactUs: React.FC<{}> = () => {
  const dispatch = useDispatch();

  const handleOpenContactSupport = useCallback(() => {
    dispatch(contactSupportFlag(true));
    dispatch(setHeaderPanelExpand({ panel: 'account', isOpen: false }));
  }, [dispatch]);

  return (
    <div className="contact-us">
      <p>
        Need help?
        <Button
          className="bx--link"
          kind="ghost"
          onClick={handleOpenContactSupport}
        >
          Contact us
        </Button>
      </p>
    </div>
  );
};

export default ContactUs;
